import { render, staticRenderFns } from "./bindWX.vue?vue&type=template&id=d6afb036&scoped=true"
import script from "./bindWX.vue?vue&type=script&lang=js"
export * from "./bindWX.vue?vue&type=script&lang=js"
import style0 from "./bindWX.vue?vue&type=style&index=0&id=d6afb036&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6afb036",
  null
  
)

export default component.exports